var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"border-svg"},[_c('div',{staticClass:"title"},[_vm._t("title",function(){return [_c('img',{staticStyle:{"margin-right":"10px"},attrs:{"src":require("@/assets/titleicon.svg")}}),_vm._v(" 近7日用户增长")]})],2),_vm._t("tabledata")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }